import { useState, useRef, useEffect } from "react";
import { ReactComponent as SummaryIcon } from "./summary.svg";
import { Sidebar, SidebarBody } from "../../../catalyst/sidebar";
import { useSelector, useDispatch } from "react-redux";
import DoughnutChart from "./doughnut";
import BarChartComponent from "./barchart";
import { Auth } from "aws-amplify";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

import { updateTabStates, setUserSurveys, setSurveys } from "../../../store/actions";

import { addSurveyFromAPI } from "../../../services/surveyService";

export default function Summary() {

  const dispatch = useDispatch();

  const themeMode = useSelector((state) => state.themeMode);
  // const currentSurvey = useSelector((state) => state.currentSurvey);
  const surveys = useSelector((state) => state.surveys);
  const userSurveys = useSelector((state) => state.userSurveys);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  const currentSurvey = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.currentSurvey;
  // const userSurveys = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.userSurveys;
  const parentRef = useRef(null); // Parent div referansı
  const [parentHeight, setParentHeight] = useState(0); // Parent'ın yüksekliğini tutacak state
  let [token, setToken] = useState("");
  const [resetSurveyWarningShow, setResetSurveyWarningShow] = useState(false);
  const [endSurveyWarningShow, setEndSurveyWarningShow] = useState(false);

  useEffect(() => {
    getToken();
  }, []);

  async function getToken(token) {
    if (token) {
      setToken(token);
    } else {
      const currentSession = await Auth.currentSession();
      setToken(currentSession.idToken.jwtToken);
    }
  }

  useEffect(() => {
    // Parent yüksekliğini hesapla ve state'e set et
    if (parentRef.current) {
      setParentHeight(parentRef.current.offsetHeight);
      console.log(parentRef.current.offsetHeight, parentHeight)
    }

    // Ekran boyutu değiştikçe güncelleme yapabilmek için resize event listener ekliyoruz
    const handleResize = () => {
      if (parentRef.current) {
        setParentHeight(parentRef.current.offsetHeight);
      }
    };

    window.addEventListener('resize', handleResize);

    // Cleanup: component unmount olduğunda event listener'ı temizle
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    console.log(parentHeight); // Burada doğru güncellenmiş parentHeight'i görebilirsiniz
  }, [parentHeight])

  const [visibleTooltip, setVisibleTooltip] = useState({});
  const doghnutData = [
    {
      name: "Filled",
      value: userSurveys.filter(
        (us) => us.survey_id === currentSurvey.ID && us.is_completed === true
      ).length,
    },
    {
      name: "Not Filled",
      value: userSurveys.filter(
        (us) => us.survey_id === currentSurvey.ID && us.is_completed === false
      ).length,
    },
  ];
  console.log(doghnutData[0]?.value);
  const filledValue = doghnutData[0]?.value || 0; // Filled değeri
  const totalValue = doghnutData.reduce((sum, item) => sum + item.value, 0); // Toplam değer
  const percentage =
    totalValue > 0 ? ((filledValue / totalValue) * 100).toFixed(2) : 0; // Oran
  const COLORS = ["#60a5fa", "#A7F3D0"]; // Renkler
  const [activeData, setActiveData] = useState([]); // Default saatlik veri
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  const formatDate = (value) => {
    if (!value) return "";
    return new Date(value).toLocaleDateString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const calculateSurveyPageCount = () => {
    let pageCount = 0;
    currentSurvey?.content?.pages
      ?.filter((x) => x.name !== "intro")
      .forEach((page) => {
        pageCount += page?.elements[0]["elements"]?.filter(
          (x) => x.type === "html"
        ).length;
      });
    return pageCount;
  };

  const calculateSurveyQuestionCount = () => {
    let questionCount = 0;
    currentSurvey?.content?.pages
      ?.filter((x) => x.name !== "intro")
      .forEach((page) => {
        questionCount += page?.elements[0]["elements"]?.filter(
          (x) => x.type !== "html"
        ).length;
      });
    return questionCount;
  };

  const getHourlyIntervals = () => {
    const intervals = [];
    const currentDate = new Date();
    for (let i = 0; i <= 44; i++) {
      const pastDate = new Date(currentDate);
      pastDate.setHours(currentDate.getHours() - i);
      pastDate.setMinutes(0, 0, 0);
      intervals.push(
        pastDate.toLocaleString("en-US", {
          weekday: "short",
          hour: "numeric",
          hour12: true,
        })
      );
    }
    console.log("intervals : ", intervals);
    const completedTimes = userSurveys
      .filter((us) => us.survey_id === currentSurvey.ID && us.is_completed === true)
      .map((us) => {
        const date = new Date(us.last_updated_at);
        date.setMinutes(0, 0, 0);
        return date.toLocaleString("en-US", {
          weekday: "short",
          hour: "numeric",
          hour12: true,
        });
      });
    console.log("completedTimes : ", completedTimes);

    return intervals.reverse().map((interval) => ({
      time: interval,
      value: completedTimes.filter((time) => time === interval).length,
    }));
  };

  const getWeeklyIntervals = () => {
    const intervals = [];
    const currentDate = new Date();
    for (let i = 0; i <= 6; i++) {
      const pastDate = new Date(currentDate);
      pastDate.setDate(currentDate.getDate() - i);
      pastDate.setHours(0, 0, 0, 0);
      intervals.push(
        pastDate.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
        })
      );
    }
    console.log("intervals : ", intervals);
    const completedDates = userSurveys
      .filter((us) => us.survey_id === currentSurvey.ID && us.is_completed === true)
      .map((us) => {
        const date = new Date(us.last_updated_at);
        date.setHours(0, 0, 0, 0);
        return date.toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
        });
      });
    console.log("completedDates : ", completedDates);

    return intervals.reverse().map((interval) => ({
      time: interval,
      value: completedDates.filter((date) => date === interval).length,
    }));
  };

  const getMontlyIntervalsByMonth = () => {
    const intervals = [];
    const currentDate = new Date();
    for (let i = 0; i <= 6; i++) {
      const pastDate = new Date(currentDate);
      pastDate.setMonth(currentDate.getMonth() - i);
      pastDate.setHours(0, 0, 0, 0);
      intervals.push(
        pastDate.toLocaleDateString("en-US", {
          month: "2-digit",
          year: "numeric",
        })
      );
    }
    console.log("intervals : ", intervals);
    const completedDates = userSurveys
      .filter((us) => us.survey_id === currentSurvey.ID && us.is_completed === true)
      .map((us) => {
        const date = new Date(us.last_updated_at);
        date.setHours(0, 0, 0, 0);
        return date.toLocaleDateString("en-US", {
          month: "2-digit",
          year: "numeric",
        });
      });
    console.log("completedDates : ", completedDates);
    console.log(intervals.reverse().map((interval) => ({
      time: interval,
      value: completedDates.filter((date) => date === interval).length,
    })))
    return intervals.reverse().map((interval) => ({
      time: interval,
      value: completedDates.filter((date) => date === interval).length,
    }));

  };

  // useEffect(() => {
  //   const data = getMontlyIntervalsByMonth();
  //   setActiveData(data);
  //   console.log("getMontlyIntervalsByMonth : ", data);
  // }, [userSurveys]);

  useEffect(() => {
    const data = getMontlyIntervalsByMonth();
    setActiveData(data);
  }, [currentSurvey, userSurveys]);

  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    // Menü dışına tıklamayı dinle
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const [expanded, setExpanded] = useState(true); // Başlangıçta açık
  const [isSmallScreen, setIsSmallScreen] = useState(false); // Küçük ekran kontrolü

  // Ekran boyutunu izleyerek durumu güncelle
  useEffect(() => {
    const handleResize = () => {
      console.log(window.innerWidth < 1280)
      setIsSmallScreen(window.innerWidth < 1280); // 1024px altı için true
    };

    handleResize(); // İlk kontrol
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Küçük ekranda her zaman kapalı başlasın
  useEffect(() => {
    if (isSmallScreen) {
      setExpanded(false);
    }
    else {
      setExpanded(true);
    }
  }, [isSmallScreen]);
  const toggleSidebar = () => {
    setExpanded(!expanded); // Toggle işlemi
  };
  const handleMouseEnter = (id) => {
    console.log(id);
    setVisibleTooltip((prev) => ({ ...prev, [id]: true }));
  };

  const handleMouseLeave = (id) => {
    setVisibleTooltip((prev) => ({ ...prev, [id]: false }));
  };

  async function surveyAction(actionType) {
    dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', true));
    setResetSurveyWarningShow(false);
    setEndSurveyWarningShow(false);
    const obj = {
      survey_id: currentSurvey.ID,
      action_type: actionType
    };
    await addSurveyFromAPI(token, obj)
      .then((result) => {
        console.log('survey action : ', result);
        let _currentSurvey = JSON.parse(JSON.stringify(currentSurvey));
        if (actionType === "reset_survey") {
          _currentSurvey.status = "Draft";
          const _userSurveys = userSurveys.filter((us) => us.survey_id !== currentSurvey.ID);
          dispatch(setUserSurveys(_userSurveys));
          const _surveys = JSON.parse(JSON.stringify(surveys));
          _surveys.find((x) => x.ID === currentSurvey.ID).status = "Draft";
          dispatch(setSurveys(_surveys));
          dispatch(updateTabStates(topMenuTabs.activeTab, 'surveyRecipients', []));
        } else if (actionType === "end_survey") {
          _currentSurvey.status = "Completed";
          _currentSurvey.end_date = new Date().toISOString();
        }
        dispatch(updateTabStates(topMenuTabs.activeTab, 'currentSurvey', _currentSurvey));
      })
      .catch((error) => {
        console.log("add survey error : ", error);
        if (error.message === "Request failed with status code 400") {
          console.log("add survey error : ", error.response.data);
        }
      }).finally(() => {
        dispatch(updateTabStates(topMenuTabs.activeTab, 'pageIsLoading', false));
      });
  }

  return (
    <div className="flex h-full " ref={parentRef}>
      <div
        className={`w-full h-full  xl:w-[calc(100%-400px)] flex align-center space-y-8 py-4 summary-component flex-col h-full  ${!expanded ? "pr-[4.25rem]" : ""} ${themeMode === "dark" ? "bg-[#1a1a28]" : "bg-[#ffffff]"
          } `}
      >
        <div
          className={`flex flex flex-col items-center space-y-6  w-full overflow-y-auto overflow-x-hidden  ${themeMode === "dark" ? "bg-[#1a1a28]" : "bg-[#ffffff]"
            }`}
        >
          <div
            className={` overflow-hidden flex flex-col items-center space-y-4 ${themeMode === "dark"
              ? "bg-[rgba(222,_222,_240,_0.04)]"
              : "bg-[#f7f7f7]"
              } rounded-[0.25rem] px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6 w-full xl:w-6/12`}
          >
            <div className="flex justify-between w-full">
              <span
                className={`  font-bold  whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0  text-[16px] ${themeMode === "dark"
                  ? "text-white text-opacity-60"
                  : "text-black text-opacity-60"
                  }`}
              >
                RESPONSE TIME
              </span>
              <div className="relative">
                {/* Menü Butonu */}
                <button
                  ref={buttonRef}
                  onClick={() => setIsMenuOpen((prev) => !prev)}
                  className={`px-2 rounded-md  ${themeMode === "dark"
                    ? "bg-gray-800 text-white"
                    : "bg-black-06 text-black"
                    }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                    />
                  </svg>
                </button>

                {/* Menü İçeriği */}
                {isMenuOpen && (
                  <div
                    ref={menuRef}
                    className={`absolute right-0 mt-2 p-2  ${themeMode === "dark"
                      ? "bg-[#2a2939]  border-[#ffffff05]"
                      : "bg-white border-black-06"
                      } shadow-lg rounded-md border  z-10 flex flex-col space-y-2 w-`}
                  >
                    <button
                      className={`text-[0.875rem] p-2 border rounded-md flex items-center justify-center min-w-[4.5rem] max-w-[4.9rem] ${themeMode === "dark"
                        ? "bg-[#2c3040]  border-[#ffffff05] text-[#C1C9D6] hover:bg-[#a5bdff10] hover:text-[#FFFFFF]"
                        : "bg-[#f0f0f0] border-black-06  text-[#5a667e] hover:bg-gray-200 hover-text-[#000]"
                        }`}
                      onClick={() => setActiveData(getHourlyIntervals())}
                    >
                      Hourly
                    </button>
                    <button
                      className={`text-[0.875rem] p-2 border rounded-md flex items-center justify-center min-w-[4.5rem] max-w-[4.9rem] ${themeMode === "dark"
                        ? "bg-[#2c3040]  border-[#ffffff05] text-[#C1C9D6] hover:bg-[#a5bdff10] hover:text-[#FFFFFF]"
                        : "bg-[#f0f0f0] border-black-06  text-[#5a667e] hover:bg-gray-200 hover-text-[#000]"
                        }`}
                      onClick={() => setActiveData(getWeeklyIntervals())}
                    >
                      Weekly
                    </button>
                    <button
                      className={`text-[0.875rem] p-2 border rounded-md flex items-center justify-center min-w-[4.5rem] max-w-[4.9rem] ${themeMode === "dark"
                        ? "bg-[#2c3040]  border-[#ffffff05] text-[#C1C9D6] hover:bg-[#a5bdff10] hover:text-[#FFFFFF]"
                        : "bg-[#f0f0f0] border-black-06  text-[#5a667e] hover:bg-gray-200 hover-text-[#000]"
                        }`}
                      onClick={() => setActiveData(getMontlyIntervalsByMonth())}
                    >
                      Monthly
                    </button>
                  </div>
                )}
              </div>
            </div>

            <BarChartComponent data={activeData} themeMode={themeMode} />
            {/* <ResponsiveContainer width="90%" height={200}>
                            <BarChart
                                data={activeData}
                                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                            >
                                <CartesianGrid strokeDasharray="3 0" vertical={false} />
                                <XAxis
                                    dataKey={"time"}
                                    tick={{ fill: themeMode === "dark" ? "#FFFFFF" : "#000000" }}
                                />
                                <YAxis
                                    tick={{ fill: themeMode === "dark" ? "#FFFFFF" : "#000000" }}
                                />
                                <Tooltip />
                                <Bar dataKey="value" fill="#60a5fa" isAnimationActive={false} />
                            </BarChart>
                        </ResponsiveContainer> */}
          </div>
        </div>
        <div
          className={`flex flex-grow  flex flex-col items-center  w-full overflow-y-auto overflow-x-hidden  ${themeMode === "dark" ? "bg-[#1a1a28]" : "bg-[#ffffff]"
            }`}
        >
          <div
            className={` overflow-hidden flex flex-col items-center space-y-4 ${themeMode === "dark"
              ? "bg-[rgba(222,_222,_240,_0.04)]"
              : "bg-[#f7f7f7]"
              } rounded-[0.25rem] px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6 w-full xl:w-6/12`}
          >
            <div className="flex justify-start w-full">
              <span
                className={`  font-bold  whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0  text-[16px] ${themeMode === "dark"
                  ? "text-white text-opacity-60"
                  : "text-black text-opacity-60"
                  }`}
              >
                COMPLETION RATE
              </span>
            </div>
            <DoughnutChart data={doghnutData} themeMode={themeMode} />
            <span
              className={`  font-bold  whitespace-nowrap break-all overflow-hidden text-ellipsis min-w-0 text-[16px]  ${themeMode === "dark"
                ? "text-white text-opacity-60"
                : "text-black text-opacity-60"
                }`}
            >
              {percentage}%
            </span>
          </div>
        </div>
      </div>
      <div
        style={{ height: `${parentHeight - 90}px` }}
        className={`transition-all ease-in-out duration-300 absolute top-25 right-0 overflow-x-hidden overflow-y-auto z-10 ${isSmallScreen ? "flex " : ""}`}// Ekran xl'den küçükse sağdan kayacak
      >
        <Sidebar
          className={`border-l w-full border-solid ${themeMode === "dark" ? "border-white-06" : "border-black-06"
            }  ${expanded ? "w-[auto] sm:w-[400px]  translate-x-0" : "w-0 hidden translate-x-full"
            } 
          xl:right-0 xl:w-[400px] xl:translate-x-0`}
        >
          <SidebarBody
            className={`  ${themeMode === "dark" ? "bg-[#14141f]" : "bg-[#fbfbfc]"
              }`}
          >
            <dl
              className={`mt-2 divide-y ${themeMode === "dark" ? "divide-white/5" : " divide-gray-200"
                }  `}
            >
              <div className="flex justify-between py-3 px-3 text-sm font-medium">
                <dt
                  className={`font-medium  ${themeMode === "dark"
                    ? "text-white text-opacity-60"
                    : "text-black text-opacity-60"
                    }`}
                >
                  SURVEY STATUS
                </dt>
                <dd className=" inline-flex items-center rounded-full bg-green-100 px-1.5 py-0.5 text-xs font-medium text-green-700">
                  {currentSurvey.status}
                </dd>
              </div>
              <div className="flex justify-between py-3 px-3 text-sm font-medium">
                <dt
                  className={`font-medium  ${themeMode === "dark"
                    ? "text-white text-opacity-60"
                    : "text-black text-opacity-60"
                    }`}
                >
                  TOTAL RESPONSES
                </dt>
                <dd className={`${themeMode === "dark" ? "text-white " : ""}`}>
                  {
                    userSurveys.filter(
                      (x) => x.survey_id === currentSurvey.ID && x.is_completed
                    ).length
                  }
                </dd>
              </div>
              <div className="flex justify-between py-3 px-3 text-sm font-medium">
                <dt
                  className={`font-medium  ${themeMode === "dark"
                    ? "text-white text-opacity-60"
                    : "text-black text-opacity-60"
                    }`}
                >
                  RESPONDENTS
                </dt>
                <dd className={`${themeMode === "dark" ? "text-white" : ""}`}>
                  {
                    userSurveys.filter((x) => x.survey_id === currentSurvey.ID)
                      .length
                  }
                </dd>
              </div>
              <div className="flex justify-between py-3 px-3 text-sm font-medium">
                <dt
                  className={`font-medium  ${themeMode === "dark"
                    ? "text-white text-opacity-60"
                    : "text-black text-opacity-60"
                    }`}
                >
                  CREATED
                </dt>
                <dd className={`${themeMode === "dark" ? "text-white" : ""}`}>
                  {formatDate(currentSurvey.created_at)}
                </dd>
              </div>
              <div className="flex justify-between py-3 px-3 text-sm font-medium">
                <dt
                  className={`font-medium  ${themeMode === "dark"
                    ? "text-white text-opacity-60"
                    : "text-black text-opacity-60"
                    }`}
                >
                  SECTIONS
                </dt>
                <dd className={`${themeMode === "dark" ? "text-white" : ""}`}>
                  {currentSurvey.content?.firstPageIsStarted
                    ? currentSurvey.content?.pages.length - 1
                    : currentSurvey.content?.pages?.length}
                </dd>
              </div>
              <div className="flex justify-between py-3 px-3 text-sm font-medium">
                <dt
                  className={`font-medium  ${themeMode === "dark"
                    ? "text-white text-opacity-60"
                    : "text-black text-opacity-60"
                    }`}
                >
                  PAGES
                </dt>
                <dd className={`${themeMode === "dark" ? "text-white" : ""}`}>
                  {calculateSurveyPageCount()}
                </dd>
              </div>
              <div className="flex justify-between py-3 px-3 text-sm font-medium">
                <dt
                  className={`font-medium  ${themeMode === "dark"
                    ? "text-white text-opacity-60"
                    : "text-black text-opacity-60"
                    }`}
                >
                  QUESTIONS
                </dt>
                <dd className={`${themeMode === "dark" ? "text-white" : ""}`}>
                  {calculateSurveyQuestionCount()}
                </dd>
              </div>
              <div className="flex justify-between py-3 px-3 text-sm font-medium">
                <dt
                  className={`font-medium  ${themeMode === "dark"
                    ? "text-white text-opacity-60"
                    : "text-black text-opacity-60"
                    }`}
                >
                  END DATE
                </dt>
                <dd className={`${themeMode === "dark" ? "text-white" : ""}`}>
                  {formatDate(currentSurvey.end_date)}
                </dd>
              </div>
              {currentSurvey.status !== "Draft" && (
                <div className="flex justify-center py-3 px-3 text-sm font-medium">
                  <button className={`w-full font-medium text-[#4d7ff5] disabled:text-[#a2bcf9] text-[0.875rem] py-1 px-2 border disabled:border-[#a2bcf9] bg-transparent disabled:bg-transparent hover:bg-[#ffffff0a] rounded-md
                   ${themeMode === "dark"
                      ? "text-white border-white opacity-60"
                      : "text-black border-black opacity-60"
                    }`}
                    disabled={false}
                    onClick={() => setResetSurveyWarningShow(true)}
                  >
                    RESET SURVEY
                  </button>
                </div>
              )}
              {currentSurvey.status === "In Progress" && (
                <div className="flex justify-center py-3 px-3 text-sm font-medium">
                  <button className={`w-full text-[#4d7ff5] disabled:text-[#a2bcf9] text-[0.875rem] py-1 px-2 border disabled:border-[#a2bcf9] bg-transparent disabled:bg-transparent hover:bg-[#ffffff0a] rounded-md
                   ${themeMode === "dark"
                      ? "text-white border-white opacity-60"
                      : "text-black border-black opacity-60"
                    }`}
                    disabled={false}
                    onClick={() => setEndSurveyWarningShow(true)}
                  >
                    END SURVEY
                  </button>
                </div>
              )}
            </dl>
          </SidebarBody>
        </Sidebar>
        {isSmallScreen && (
          <div
            className={`border-b-0  top-25 right-0 h-full  w-[2.5rem] sm:w-[4.25rem] ${themeMode === "dark" ? "bg-[#14141f]" : "bg-[#fbfbfc]"
              }`}
          >
            <ul>
              <li
                className="cursor-pointer "
                onMouseEnter={() => handleMouseEnter(1)} // Tooltip görünür yapılıyor
                onMouseLeave={() => handleMouseLeave(1)}
              >
                <div
                  className={`mt-4 group relative flex justify-center rounded  text-[#7F7F7F] hover:font-normal ${themeMode === "dark"
                    ? " hover:text-[rgba(255,_255,_255,_0.8)]"
                    : " hover:text-black "
                    }`}
                  onClick={toggleSidebar}
                >
                  <SummaryIcon // İç kısmı da renklendirebiliriz.
                    fill="currentColor"
                    className={`size-4 text-[#7F7F7F] ${themeMode === "dark"
                      ? "hover:text-[rgba(255,_255,_255,_0.8)]"
                      : "hover:text-black"
                      }`}
                  />
                  {visibleTooltip[1] && (
                    <div className={`tooltip absolute right z-[10000] flex justify-center w-[7.2rem] top-[13px] right-[4rem] transform -translate-y-1/2 p-2 text-center text-xs ${themeMode === "dark" ? "text-[#FFF] bg-theme-tooltip-bg" : "text-black bg-[#efeff2]"} border border-theme-popup-divider rounded shadow-theme-popup-shadow select-none flex items-center`}>
                      Open Summary
                    </div>
                  )}
                </div>
              </li>
            </ul>

          </div>
        )}
      </div>

      <Dialog
        open={resetSurveyWarningShow}
        onClose={setResetSurveyWarningShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-black opacity-50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-4 pb-0">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <DialogPanel
              transition
              className={`relative transform rounded-lg shadow-lg border border-solid ${themeMode === "dark"
                ? "bg-[#2a2939] border-white-09"
                : "bg-[#FFFFFF] border-black-09"
                } overflow-hidden px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6`}
            >
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="w-12 h-12 text-red-600"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                </div>
                <div className="ml-4">
                  <DialogTitle
                    as="h3"
                    className={`text-lg leading-6 font-medium ${themeMode === "dark" ? "text-white" : "text-gray-900"}`}
                  >
                    Warning
                  </DialogTitle>
                  <div className={`mt-2 ${themeMode === "dark" ? "text-gray-300" : "text-gray-600"}`}>
                    <p>If you reset, all surveys filled out so far will be deleted and all surveys sent will be canceled! Are you sure you want to reset survey?</p>
                  </div>
                </div>
              </div>
              <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  onClick={() => surveyAction("reset_survey")}
                  className={`inline-flex w-full justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm`}
                >
                  Yes
                </button>
                <button
                  type="button"
                  onClick={() => setResetSurveyWarningShow(false)}
                  className={`inline-flex w-full justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm`}
                >
                  No
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={endSurveyWarningShow}
        onClose={setEndSurveyWarningShow}
        className="relative z-10"
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-black opacity-50 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto px-4 pb-0">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <DialogPanel
              transition
              className={`relative transform rounded-lg shadow-lg border border-solid ${themeMode === "dark"
                ? "bg-[#2a2939] border-white-09"
                : "bg-[#FFFFFF] border-black-09"
                } overflow-hidden px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6`}
            >
              <div className="flex items-center">
                <div className="flex-shrink-0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="w-12 h-12 text-red-600"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                </div>
                <div className="ml-4">
                  <DialogTitle
                    as="h3"
                    className={`text-lg leading-6 font-medium ${themeMode === "dark" ? "text-white" : "text-gray-900"}`}
                  >
                    Warning
                  </DialogTitle>
                  <div className={`mt-2 ${themeMode === "dark" ? "text-gray-300" : "text-gray-600"}`}>
                    <p>If you end the survey, any surveys that have not yet been completed will be withdrawn! Are you sure you want to end the survey?</p>
                  </div>
                </div>
              </div>
              <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  onClick={() => surveyAction("end_survey")}
                  className={`inline-flex w-full justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm`}
                >
                  Yes
                </button>
                <button
                  type="button"
                  onClick={() => setEndSurveyWarningShow(false)}
                  className={`inline-flex w-full justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm`}
                >
                  No
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
